module.exports = __webpack_public_path__ + "static/media/pdf.worker.js.e25ae7b6df.map";


//////////////////
// WEBPACK FOOTER
// ./~/pdfjs-dist/build/pdf.worker.js.map
// module id = 6422
// module chunks = 0